import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'antd'
import AddAndEditExternalOutboundNumberModal from './AddAndEditExternalOutboundNumberModal'
import css from './contact-mapping.css'

const ExternalOutboundNumberSelect = ({
  dso,
  externalOutboundNumberModalOpen,
  externalOutboundNumbers,
  locations,
  locationId,
  outboundNumberId,
  practiceId,
  refetchLocations,
  toggleEonModal,
  saveContactInfo,
}) => {
  const selectedOutboundNumber = (id) => {
    const foundNumber = externalOutboundNumbers.find(eon => eon.id === id)
    return foundNumber.phone_number
  }

  return (
    <div className={css.wrapper} style={{ alignSelf: 'start' }}>
      <div className={css.defaultDoctorWrapper}>
        <span
          className={css.labelSmall}
          style={{ marginBottom: '5px' }}
        >
          Greyfinch Outbound Number
        </span>
        {!outboundNumberId ? (
          <Button onClick={() => toggleEonModal(true, 'add')}>
            Assign Phone Number
          </Button>
        ) : (
          <div className={css.headerWithButton}>
            <span>{selectedOutboundNumber(outboundNumberId)}</span>
            <button
              style={{ background: 'none', border: 'none', margin: 0 }}
              className={css.editButton}
              onClick={() => toggleEonModal(true, 'edit')}
            >
              <Icon type="edit" />
            </button>
          </div>
        )}
        <AddAndEditExternalOutboundNumberModal
          dso={dso}
          externalOutboundNumbers={externalOutboundNumbers}
          locations={locations}
          locationId={locationId}
          open={externalOutboundNumberModalOpen}
          outboundNumberId={outboundNumberId}
          practiceId={practiceId}
          refetchLocations={refetchLocations}
          toggleEonModal={toggleEonModal}
          saveContactInfo={saveContactInfo}
        />
      </div>
    </div>
  )
}

ExternalOutboundNumberSelect.propTypes = {
  dso: PropTypes.bool.isRequired,
  externalOutboundNumberModalOpen: PropTypes.bool.isRequired,
  externalOutboundNumbers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    phone_number: PropTypes.string.isRequired,
    active: PropTypes.bool,
    name: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    practice_id: PropTypes.number.isRequired,
  })).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  locationId: PropTypes.string.isRequired,
  outboundNumberId: PropTypes.string,
  practiceId: PropTypes.string.isRequired,
  refetchLocations: PropTypes.func.isRequired,
  toggleEonModal: PropTypes.func.isRequired,
  saveContactInfo: PropTypes.func.isRequired,
}

ExternalOutboundNumberSelect.defaultProps = {
  outboundNumberId: null,
}

export default ExternalOutboundNumberSelect



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ExternalOutboundNumberSelect.js